<div class="npf-page">
  <header class="npf-topbar">
    <img src="assets/brightsidelogo.png" alt="Brightside Counseling" class="npf-logo" />
  </header>

  <main class="npf-shell">
    <section class="npf-card">
      <span class="npf-eyebrow"><i class="pi pi-heart-fill"></i> Welcome</span>
      <h1 class="npf-title">New Patient Form</h1>
      <p class="npf-lede">
        Your journey to wellbeing starts here! This form only takes 3 minutes to complete.
      </p>
      <p class="npf-note">If you are not the patient, please enter the patient's information.</p>

      <a routerLink="/form" class="npf-cta-link">
        <p-button label="Begin" icon="pi pi-arrow-right" iconPos="right" styleClass="npf-cta" />
      </a>

      <p class="npf-footnote">
        Tell us about your preferences. We'll match you with a therapist or coach tailored to your
        unique needs.
      </p>
    </section>
  </main>
</div>
